/**
 * Utility to get auth headers from Supabase session
 * Returns headers object with Authorization bearer token if session exists
 */
import { supabase } from '../lib/supabaseClient'

export const getAuthHeaders = async () => {
  try {
    const { data: sessionData } = await supabase.auth.getSession()
    
    if (sessionData?.session?.access_token) {
      return {
        'Authorization': `Bearer ${sessionData.session.access_token}`,
        'Content-Type': 'application/json'
      }
    }
    
    return {
      'Content-Type': 'application/json'
    }
  } catch (error) {
    console.error('Error getting auth headers:', error)
    return {
      'Content-Type': 'application/json'
    }
  }
}
